import { render, staticRenderFns } from "./UdfRuntime.vue?vue&type=template&id=b87a4caa"
import script from "./UdfRuntime.vue?vue&type=script&lang=js"
export * from "./UdfRuntime.vue?vue&type=script&lang=js"
import style0 from "./UdfRuntime.vue?vue&type=style&index=0&id=b87a4caa&prod&lang=scss"


/* normalize component */
import normalizer from "!../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports